// extracted by mini-css-extract-plugin
export default {"product":"Vitamins_product__Lve+W","filterWrapper":"Vitamins_filterWrapper__6dziX","productWrapper":"Vitamins_productWrapper__QmRCu"};